import { useCallback, useState } from 'react';
import { useAsync } from './useAsync';
import { Api } from '../api';

export const useBlockedEmailDomainsHook = () => {
  const [blockedEmailDomainsTable, setBlockedEmailDomainsTable] = useState<Set<string>>(new Set());

  const loadBlockedEmailDomains = useAsync(
    useCallback(async (): Promise<void> => {
      const blockedDomains: string[] = await Api.tenants.getBlockedEmailDomains();
      const lookupTable = new Set(blockedDomains);
      setBlockedEmailDomainsTable(lookupTable);
    }, []),
    { autoReset: true }
  );

  return { loadBlockedEmailDomains, blockedEmailDomainsTable };
};
